import API from "../utilities/LocalApiProxy";
import { openGlobalDialog } from "./globalEditDialogActions";
import { isRateLimitError } from "./errorActions";
import { CLOSE_GLOBAL_EDIT_DIALOG, GLOBAL_DIALOG_VALIDATE } from "./types";
import {
	documentMap,
	emailMap,
	notesMap,
	directoryMap,
} from "../utilities/itemMappers";

function matterMap(matters) {
	return matters.map((item) => {
		return {
			type: "Matter",
			id: item.matterID,
			matterName: item.matterName,
			clientName: item.clientName,
			customMatterID: item.customMatterID,
			matterType: item.matterType,
			officeBranch: item.officeBranch,
			dateOpened: item.dateOpened,
			dateClosed: item.dateClosed,
			tags: item.tags,
			assignedStaff: item.assignedStaff,
		};
	});
}

function clientMap(clients) {
	return clients.map((item) => {
		return {
			type: "Client",
			id: item.clientID,
			clientName: item.clientName,
		};
	});
}

export function listTrash({ trashPageContext }) {
	return function (dispatch) {
		dispatch({ type: "GET_TRASH_REQUEST", payload: { trashPageContext } });
		API.post("/trash/list", { body: { trashPageContext } })
			.then((results) => {
				if (
					trashPageContext !==
					window.location.pathname.split("/").filter(Boolean)[1]
				) {
					console.log(
						"trashPageContext no longer matches the trash path. Will not update the trash state."
					);
					// if the context is not the same as the current path, do not update the state
					return;
				}

				if (trashPageContext === "docs") {
					const files = documentMap(results.mysql.docsInTrash);
					const directories = directoryMap(
						results.mysql.foldersInTrash,
						"File"
					);
					dispatch({
						type: "GET_TRASH_SUCCESS",
						payload: {
							trashList: files.concat(directories),
						},
					});
				}

				if (trashPageContext === "email") {
					const emails = emailMap(results.mysql.emailsInTrash);
					const directories = directoryMap(
						results.mysql.foldersInTrash,
						"Email"
					);
					dispatch({
						type: "GET_TRASH_SUCCESS",
						payload: {
							trashList: emails.concat(directories),
						},
					});
				}

				if (trashPageContext === "notes") {
					const notes = notesMap(results.mysql.notesInTrash, "Note");
					const directories = directoryMap(
						results.mysql.foldersInTrash,
						"Note"
					);
					dispatch({
						type: "GET_TRASH_SUCCESS",
						payload: {
							trashList: notes.concat(directories),
						},
					});
				}

				if (trashPageContext === "matters") {
					const matters = matterMap(results.mysql.mattersInTrash);
					dispatch({
						type: "GET_TRASH_SUCCESS",
						payload: {
							trashList: matters,
						},
					});
				}
				if (trashPageContext === "clients") {
					const clients = clientMap(results.mysql.clientsInTrash);
					dispatch({
						type: "GET_TRASH_SUCCESS",
						payload: {
							trashList: clients,
						},
					});
				}

				if (trashPageContext === "activity") {
					const jobs = results.mysql.jobsInTrash.map((item) => {
						let status =
							item.percentDone === 100
								? "Completed"
								: `${item.percentDone}% Complete`;
						if (item.status === 3) {
							status = "Failed";
						}
						return {
							type: "job",
							id: item.id,
							jobType: item.type,
							status,
							endTime: item.endTime,
							startTime: item.startTime,
							userSub: item.userSub,
							userPerformingOperationDisplayName:
								item.userPerformingOperationDisplayName,
						};
					});
					dispatch({
						type: "GET_TRASH_SUCCESS",
						payload: {
							trashList: jobs,
						},
					});
				}
			})
			.catch((err) => {
				console.error("error in fetching trash list", err);
				dispatch({
					type: "GET_TRASH_FAILURE",
					payload: { rateLimited: isRateLimitError(err) },
				});
			});
	};
}

export function getPermanentDeleteJobDetails(jobID) {
	return function (dispatch) {
		openGlobalDialog(
			{
				label: `Permanent Delete Job Details`,
				canSubmit: false,
				hideTextfield: true,
				type: "permanentDeleteJobDetails",
				cancelButtonLabel: "Close",
				readOnly: true,
				extraCSSClass: "WideEditDialog",
				permanentDeleteJobDetailsObject: {
					loading: true,
				},
			},
			() => {}, // submit function
			() => {}, // validate function
			() => {
				// cancel function
				dispatch({
					type: CLOSE_GLOBAL_EDIT_DIALOG,
				});
			}
		)(dispatch);

		API.post("/trash/jobDetails", { body: { jobID } })
			.then((results) => {
				dispatch({
					type: GLOBAL_DIALOG_VALIDATE,
					payload: {
						permanentDeleteJobDetailsObject: {
							loading: false,
							...results.mysql,
						},
					},
				});
			})
			.catch((err) => {
				console.error("error in fetching job details", err);
				dispatch({
					type: GLOBAL_DIALOG_VALIDATE,
					payload: {
						permanentDeleteJobDetailsObject: {
							loading: false,
							error: err.message || "Failed to load job details",
						},
					},
				});
			});
	};
}
